module.exports = __webpack_public_path__ + "img/card_feature_3_grand_cherokee.79836888.jpg";